export default "__VITE_ASSET__CeIsf3I1__"